module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAANBJREFUSEvtlMsKAjEMRc/gH7pRUBndiv6NuvWBgiv/UJRACrVM2kxldtN1OKf3BtIw8GsG5jMKig33qUhmp0p8AZ8iHdw7EPgB2Cr0COw9Ek+CFB4+7pKUBBY8SE7ALpckJ+iCPxS2jPrPSiyBBW8VfAFcki5BDv5WwQRwSVKBBx7acUliQR94LLkCC2snQVADd0kE/A+8KBH4DHhGEe/AGggL9VwEmZGdpHXNRbACbkqphVtJWhGIeaMT54qfpwl/eKVT4a3HnBsFxQoHr+gLX8090niBa7cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/top-arrow.png
// module id = nIgG
// module chunks = 1